import { getGroupAuthType } from "@/utils/authToken";
import { httpAuth2 } from "@/api/auth";

import { GROUP_AUTH_HEADER_NAME } from "../constants";

export const workingHourRequests = {
  saveWorkingHours: ({ context, username, workingHours } = {}) => {
    return httpAuth2
      .post("/v1/working_hours", {
        context,
        headers: { [GROUP_AUTH_HEADER_NAME]: getGroupAuthType() },
        json: { username, working_hours: workingHours },
      })
      .json();
  },
};
